import { InternalPrivilegeGrant } from './grants/internal-privilege-grant';
import { PlaceholderGrant } from './grants/placeholder-grant';
import { PrivilegeGrant } from './grants/privilege-grant';

const readApps = new PrivilegeGrant('apps.read');
const viewCalibrationPage = new PrivilegeGrant('calibration.read');
const writeCalibrationSettings = new PrivilegeGrant('calibration.write');
const writeApps = new PrivilegeGrant('apps.write');
const writeCommands = new PrivilegeGrant('command.execute');
const readIOStatus = new PrivilegeGrant('hardware.read');
const writeIOStatus = new PrivilegeGrant('hardware.write');
const readDevicePresentations = new PrivilegeGrant('devicepresentations.read');
const startBlast = new PrivilegeGrant('blast.start');
const stopBlast = new PrivilegeGrant('blast.stop');
const readBlast = new PrivilegeGrant('blast.read');

const acknowledgeAlarms = new PrivilegeGrant('facilityalert.acknowledge');
const acknowledgeAlarmsCritical = new PrivilegeGrant('facilityalert.acknowledge.critical');
const resetAlarms = new PrivilegeGrant('facilityalert.reset');
const readAlarmActivations = new PrivilegeGrant('alarmactivations.read');

const readPAC = new InternalPrivilegeGrant('pac.read');
const writePAC = new InternalPrivilegeGrant('pac.write');
const inviteUser = new InternalPrivilegeGrant('invitation.write');
const viewInvitations = new InternalPrivilegeGrant('invitation.read');
const listUsers = new InternalPrivilegeGrant('users.read');
const readFacilityManagement = new InternalPrivilegeGrant('facility.read');
const writeFacilityManagement = new InternalPrivilegeGrant('facility.write');
const editUsers = new InternalPrivilegeGrant('users.write');
const editUserAccess = new InternalPrivilegeGrant('acl.write');
const viewAlarmSubscriptions = new InternalPrivilegeGrant('alarmsubscriptions.read');
const editAlarmSubscriptions = new InternalPrivilegeGrant('alarmsubscriptions.write');
const viewDeployments = new InternalPrivilegeGrant('deployment.read');
const editDeployments = new InternalPrivilegeGrant('deployment.write');
const viewSiteNarrative = new InternalPrivilegeGrant('controlconfig.read');
const editSiteNarrative = new InternalPrivilegeGrant('controlconfig.write');
const editProcessView = new InternalPrivilegeGrant('prv.write');
const editDevicePresentations = new InternalPrivilegeGrant('devicepresentations.write');
const editBlueprint = new InternalPrivilegeGrant('blueprint.write');
const readUxds = new InternalPrivilegeGrant('uxds.read');
const writeUxds = new InternalPrivilegeGrant('uxds.write');
const readDemandResponse = new InternalPrivilegeGrant('demandresponse.read');
const writeDemandResponse = new InternalPrivilegeGrant('demandresponse.write');

const accessChecked = new PlaceholderGrant('N/A', true);

export const grantTable = {
  readApps,
  viewCalibrationPage,
  writeCalibrationSettings,
  writeApps,
  writeCommands,
  readIOStatus,
  writeIOStatus,
  readDevicePresentations,
  startBlast,
  stopBlast,
  readBlast,
  acknowledgeAlarms,
  acknowledgeAlarmsCritical,
  resetAlarms,
  readAlarmActivations,
  readPAC,
  writePAC,
  inviteUser,
  viewInvitations,
  listUsers,
  readFacilityManagement,
  writeFacilityManagement,
  editUsers,
  editUserAccess,
  viewAlarmSubscriptions,
  editAlarmSubscriptions,
  viewDeployments,
  editDeployments,
  viewSiteNarrative,
  editSiteNarrative,
  editProcessView,
  editDevicePresentations,
  editBlueprint,
  readUxds,
  writeUxds,
  readDemandResponse,
  writeDemandResponse,
  accessChecked,
} as const;

export type AccessKey = keyof typeof grantTable;

// Typed privilege constants to replace magic strings
export const PRIVILEGES = {
  readApps: 'readApps',
  viewCalibrationPage: 'viewCalibrationPage',
  writeCalibrationSettings: 'writeCalibrationSettings',
  writeApps: 'writeApps',
  writeCommands: 'writeCommands',
  readIOStatus: 'readIOStatus',
  writeIOStatus: 'writeIOStatus',
  readDevicePresentations: 'readDevicePresentations',
  startBlast: 'startBlast',
  stopBlast: 'stopBlast',
  readBlast: 'readBlast',
  acknowledgeAlarms: 'acknowledgeAlarms',
  acknowledgeAlarmsCritical: 'acknowledgeAlarmsCritical',
  resetAlarms: 'resetAlarms',
  readAlarmActivations: 'readAlarmActivations',
  readPAC: 'readPAC',
  writePAC: 'writePAC',
  inviteUser: 'inviteUser',
  viewInvitations: 'viewInvitations',
  listUsers: 'listUsers',
  readFacilityManagement: 'readFacilityManagement',
  writeFacilityManagement: 'writeFacilityManagement',
  editUsers: 'editUsers',
  editUserAccess: 'editUserAccess',
  viewAlarmSubscriptions: 'viewAlarmSubscriptions',
  editAlarmSubscriptions: 'editAlarmSubscriptions',
  viewDeployments: 'viewDeployments',
  editDeployments: 'editDeployments',
  viewSiteNarrative: 'viewSiteNarrative',
  editSiteNarrative: 'editSiteNarrative',
  editProcessView: 'editProcessView',
  editDevicePresentations: 'editDevicePresentations',
  editBlueprint: 'editBlueprint',
  readUxds: 'readUxds',
  writeUxds: 'writeUxds',
  readDemandResponse: 'readDemandResponse',
  writeDemandResponse: 'writeDemandResponse',
  accessChecked: 'accessChecked',
} as const;

export type PrivilegeKey = keyof typeof PRIVILEGES;
